module.exports = __webpack_public_path__ + "static/media/trade.fcc3d55e.png";